export default __webpack_public_path__ + "static/media/shirt4.25b0d0f7.jpeg";